import type { IQueryVariablesType } from "./types";

//  select and filters
export const FAMILY_MEMBER = "/dropdown/family-members/:user_id";
export const FAMILY_MEMBER_WITH_PARENT = "/dropdown/family-members-with-parent";
export const PAYMENT = "/dropdown/appointment-payment-methods";
export const MEDICAL_DEVICE_TYPE = "/dropdown/medical-device-type";
export const RELATIONSHIP = "/dropdown/relationship-types";
export const GENDER = "/dropdown/gender";
export const HF_TYPE = "/dropdown/facility/types";
export const CLINICAL_ORDER_TYPE = "/dropdown/clinical-order-type";
export const DOCTOR_DEGREE = "/dropdown/doctor-degree";
export const LANGUAGE_SKILL = "/dropdown/language-skill";
export const DAYS = "/dropdown/days";
export const VISIT_TYPE = "/dropdown/visit-type";
export const TEST_TYPE = "/dropdown/intake-form-test-types";
export const NOTIFIABLE_ROLES = "/dropdown/notifiable-roles";
export const MESSAGING_ROLES = "/dropdown/messaging-roles";
export const DEVICE_TYPES = "/dropdown/device-types";

//  independent autocomplete
export const TIMEZONE = "/dropdown/timezones";
export const SPECIALITY = "/dropdown/doctors-specialities";
export const LANGUAGE = "/dropdown/language";
export const MEDICINE_NAME = "/dropdown/medicine-name";
export const MEDICINE_TYPE = "/dropdown/medicine-type";
export const COUNTRY = "/dropdown/countries";
export const USAGE_DURATIONS = "/dropdown/usage-durations";
export const USAGE_AMOUNTS = "/dropdown/usage-amounts";
export const USAGE_APPROACHES = "/dropdown/usage-approaches";
export const REUSE_INTERVALS = "/dropdown/reuse-intervals";

// dependent autocomplete
export const STATE = "/dropdown/countries/:country_id/states";
export const CITY = "/dropdown/states/:state_id/cities";
export const COUNTRY_TIMEZONE = "/dropdown/countries/:country_id/timezones";
export const MEDICINE_DOSAGE = "/dropdown/medicine-dosage/:medicineName";
export const MEDICINE_FORMULATION =
  "/dropdown/medicine-formulation/:medicineName/:medicineDosage";
export const MESSAGING_USERS_LIST = "/dropdown/messaging-users-list";
export const USERS_LIST = "/dropdown/users/:role";
export const VISIT_HISTORIES =
  "/dropdown/prescription-histories/:summaryNoteId/:type";
export const SUB_SPECIALTY =
  "/dropdown/doctors-subspecialities/:parent_speciality_id";
export const MSP_TYPE = "/medical-service-provider/dropdown/msp-types";

export interface IMessagingRolesListType {
  role_name: string;
}

//  multiselect
export const ALL_DEPARTMENTS = "/dropdown/department-names";
export const HF_DEPARTMENT = "/dropdown/departments/:hf_id";

//  other dropdowns
export const INTAKE_FORM_QUESTIONS = "/dropdown/intake-form-questions";

// #region path params

// #endregion

export const dropdownURLs = {
  allDepartments: ALL_DEPARTMENTS,
  orderType: CLINICAL_ORDER_TYPE,
  doctorEducation: DOCTOR_DEGREE,
  familyMember: FAMILY_MEMBER,
  hfType: HF_TYPE,
  languageSkills: LANGUAGE_SKILL,
  medicalDeviceType: MEDICAL_DEVICE_TYPE,
  medicineType: MEDICINE_TYPE,
  city: CITY,
  country: COUNTRY,
  dosage: MEDICINE_DOSAGE,
  gender: GENDER,
  medicineName: MEDICINE_NAME,
  paymentMethod: PAYMENT,
  relationship: RELATIONSHIP,
  speciality: SPECIALITY,
  state: STATE,
  timezone: TIMEZONE,
  countryTimezone: COUNTRY_TIMEZONE,
  days: DAYS,
  visitType: VISIT_TYPE,
  medicineFormulation: MEDICINE_FORMULATION,
  testType: TEST_TYPE,
  intakeFormQuestions: INTAKE_FORM_QUESTIONS,
  notifiableRoleType: NOTIFIABLE_ROLES,
  messagingRoleType: MESSAGING_ROLES,
  messagingUsersList: MESSAGING_USERS_LIST,
  deviceType: DEVICE_TYPES,
  userName: USERS_LIST,
  subSpeciality: SUB_SPECIALTY,
  familyMemberWithParent: FAMILY_MEMBER_WITH_PARENT,
  usageDuration: USAGE_DURATIONS,
  usageAmount: USAGE_AMOUNTS,
  usageApproach: USAGE_APPROACHES,
  reuseInterval: REUSE_INTERVALS,
  visitHistories: VISIT_HISTORIES,
  mspType: MSP_TYPE,
} satisfies Record<IQueryVariablesType["optionType"], string>;

// #region dropdowns

// #endregion
